import "./App.css";
import Login from "./auth/Login";
import SideBar from "./components/SideBar";
import NotCollectted from "./pages/NotCollectted";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import { QueryClient, QueryClientProvider } from "react-query";
// import AccessCheck from "./auth/AccessCheck";

function App() {
  const queryClient = new QueryClient();

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/home-page" element={<SideBar />} />
          <Route path="/shipment-not-collected" element={<NotCollectted />} />
        </Routes>
        {/* <AccessCheck /> */}
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
